export default {"src":"/_next/static/media/accepted.bb84c0a4.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};